import BackgroundView from "components/views/BackgroundView";
import AppStack from "features/AppStack";
import "./App.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  return (
    <BackgroundView>
      <GoogleOAuthProvider clientId="1047825202135-gd8b17rh6jik7j8nk47hnj7ogkd2lvlm.apps.googleusercontent.com">
        <AppStack />
      </GoogleOAuthProvider>
    </BackgroundView>
  );
}

export default App;
